import React from 'react';
import { useParams } from 'react-router-dom';
// import RichTextEditor from 'react-rte';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { useDeleteDashboard } from 'hooks/useDashboard';

import MenuControls from 'components/Widget/components/menus/MainSettings/components/MenuControls';
import LoadingSpinner from 'components/LoadingSpinner';
import { Message } from 'components/shared';

const useStyles = makeStyles({
  root: {
    flexGrow: 1
  },
  rootInput: {
    '& .MuiOutlinedInput-input': {
      padding: '15px 14px'
    }
  },
  modal_subtitle: {
    marginBottom: '30px'
  },
  test: {
    cursor: 'pointer',
    '& > div > img': {
      filter: 'blur(1.1px)'
    },
    '&:hover': {
      zIndex: 10,
      transform: 'scale(1.13)',
      '& > div ': {
        boxShadow: '0px 12px 33px 4px rgba(0,0,0,0.53)'
      },
      '& > div > img': {
        filter: 'unset'
      }
    }
  },
  scroll: {
    '&::-webkit-scrollbar': {
      width: '8px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
      backgroundClip: 'padding-box',
      borderRadius: '10px',
      border: `3px solid transparent`
    },
    '&::-webkit-scrollbar-button': {
      width: '0',
      height: '0',
      display: 'none'
    },
    '&::-webkit-scrollbar-corner': {
      display: 'none'
    }
  }
});

const DeletePopup = ({ onClose }) => {
  const classes = useStyles();
  const { id } = useParams();

  const [deleteState, deleteDashboard] = useDeleteDashboard();
  const { isLoading: isDeleteLoading, isError: isDeleteError, error: deleteError } = deleteState;

  const handleDelete = () => {
    deleteDashboard({ id });
  };

  return (
    <Box p={2}>
      <h2>Are you sure you want to remove this dashboard?</h2>
      <Typography className={classes.modal_subtitle} gutterBottom>
        You will permanently delete this dashboard without the option for recovery of your changes.
      </Typography>

      {isDeleteLoading && <LoadingSpinner />}

      {isDeleteError && <Message type="error" text={deleteError} />}

      <Box style={{ marginLeft: '-23px' }} mt={6}>
        <MenuControls handleClose={onClose} useFormSubmit={false} onSubmit={handleDelete} />
      </Box>
    </Box>
  );
};

export default DeletePopup;
